import{iterator as o}from"../symbol/iterator.js";function t(t){return t&&"function"==typeof t[o]}export{t as isIterable};
